import { ShipmentCsvDownloadError } from 'repositories/ShipmentApi/downloadTenantShipmentsCsv/ShipmentCsvDownloadError'
import { isAuthError } from 'utils/apiErrorPredicates'

const AUTH_ERROR_STATUSES = [401, 403]

const DEFAULT_ERROR_MESSAGE = 'CSVファイルのダウンロードに失敗しました。'

// WHY: 401/403 判定の本体は共通の isAuthError（TruckbookApiResponseError / AxiosError を見る）に委ねる。
// Blob DL 経路でのみ発生する ShipmentCsvDownloadError だけをここで足す（HTTP ステータス定義を 2 箇所に散らさない）。
export const isAuthDownloadError = (error: unknown): boolean =>
  isAuthError(error) ||
  (error instanceof ShipmentCsvDownloadError &&
    error.httpStatus !== undefined &&
    AUTH_ERROR_STATUSES.includes(error.httpStatus))

export const getDownloadErrorMessage = (error: unknown): string =>
  error instanceof ShipmentCsvDownloadError && error.message ? error.message : DEFAULT_ERROR_MESSAGE
